import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './FAQcontent.css';

import { getNames } from 'country-list';

const countries = getNames();


const FAQcontent = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const [selectedCountry, setSelectedCountry] = useState('');

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "What are the different combinations available in Day & Night Colby blinds?",
            answer: "Callistus offers 3 types of fabric combinations in Colby Day & Night Blinds. 1) Blackout & Translucent Fabric 2) Sheer & Blackout Fabric 3) Sheer & Translucent Fabric"
        },
        {
            question: "What are the Operating Systems offered by Callistus?",
            answer: (
                <>
                    Callistus offers largest and most innovative range of 10 Operating Systems for various blinds. <br />
                    <Link style={{ color: "#337ab7", textDecoration: "none" }} to="/automation">Learn More</Link>
                </>
            )
        },
        {
            question: "What is the effect of Silver Foil in Fabric of blinds?",
            answer: "Silver Foil in blinds increases the quality of seamless fabrics with crisp even pleats that hold their shape indefinitely. It offers light control, sound absorption and heat & cold resistance."
        },
        {
            question: "What is Blackout, Translucent and Sheer in window blinds?",
            answer: "Callistus offers wide variety of fabrics. Some of the fabrics are Blackout, that means complete darkness in the room. Translucent fabrics allow light partially in the room, and Sheer fabrics allow sunlight and are see through."
        },
        {
            question: "What is the difference between room darkening and blackout window blinds?",
            answer: "Blackout shades use a fabric that blocks 100% of all incoming light, while “room darkening” usually refers to almost any shade that uses a fabric that blocks between 95% and 99% of the light that enters your room."
        },
        {
            question: "Are Callistus window blinds safe for children and pets?",
            answer: (
                <>
                    All of our window blinds are designed with safety in mind a responsibility we take very seriously. <br />
                    <Link style={{ color: "#337ab7", textDecoration: "none" }} to="/child-safety">Learn More</Link>
                </>
            )
        }
    ];

    return (
        <div className="FAQ-pg-content">
            <div className="faq-container">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Frequently Asked Questions</h1>
                </div>

                <div className="faq-content">
                    {/* FAQ Column */}
                    <div className="faq-column">
                        <h2>Window Blinds</h2>
                        <div className="faq-list">
                            {faqs.map((faq, index) => (
                                <div
                                    key={index}
                                    className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                                >
                                    <div
                                        className="faq-question"
                                        onClick={() => toggleFAQ(index)}
                                    >
                                        <p>{faq.question}</p>
                                        <FaChevronDown className="faq-icon" />
                                    </div>
                                    {activeIndex === index && (
                                        <div className="faq-answer">
                                            <p>{faq.answer}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Form Column */}
                    <div className="form-column">
                        <h2>ASK US</h2>
                        <p className="form-subtitle">Got another question? We'd love to help. Don't hesitate to contact us, and a Callistus consultant will respond to your request.</p>
                        <p className="form-note">All Fields Required.</p>

                        <form className="faq-form">
                            <div className="FAQ-form-group">
                                <label>YOUR QUESTION/COMMENT</label>
                                <textarea rows="4" required></textarea>
                            </div>

                            <div className="form-row">
                                <div className="FAQ-form-group half-width">
                                    <label>FIRST NAME</label>
                                    <input type="text" required />
                                </div>
                                <div className="FAQ-form-group half-width">
                                    <label>LAST NAME</label>
                                    <input type="text" required />
                                </div>
                            </div>

                            <div className="FAQ-form-group">
                                <label>EMAIL</label>
                                <input type="email" required />
                            </div>

                            <div className="form-row">
                                <div className="FAQ-form-group half-width">
                                    <label>COUNTRY</label>
                                    <select value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
                                        {countries.map((country, idx) => (
                                            <option value={country} key={idx}>{country}</option>
                                        ))}
                                    </select>

                                </div>
                                <div className="FAQ-form-group half-width">
                                    <label>CONTACT NO.</label>
                                    <input type="tel" required />
                                </div>
                            </div>

                            <button type="submit" className="submit-btn">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQcontent;